import ax from "axios";

ax.defaults.headers.post["Content-Type"] = "application/json";
ax.defaults.validateStatus = (status) => status >= 200 && status < 500;

const axios = ax.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  // baseURL: "http://127.0.0.1:8000",
});

const token = localStorage.getItem("userToken");
token && (axios.defaults.headers.common.Authorization = `Bearer ${token}`);
axios.CancelToken = ax.CancelToken;
axios.isCancel = ax.isCancel;

export default axios;
